import {STATUS_OPERATION_DISCOVERY, STATUS_RESOURCE, TIMEOUT_DISCOVER} from 'config/constants/infrastructureResources';

import {invalidateResources, discoverResources } from 'modules/store/resources';
import {invalidateAccounts} from 'modules/store/accounts';
import {invalidateRegions} from 'modules/store/regions';
import {invalidateVmStates} from 'modules/store/vmStates';
import {invalidateVendors, vendorCodes} from 'modules/store/vendors';
import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {addNotification, NOTIFICATION_TYPE} from 'modules/notifications';

import {changeSelectedRows, TAG_INFRASTRUCTURE_RESOURCES} from 'modules/ui';

import {INIT_INDEX, INFRASTRUCTURE_ACTIONS} from 'util/constants';
import { ZERO } from '../util/constants';

const _defaultState = () => ({
    activeButtons:       [INFRASTRUCTURE_ACTIONS.DISCOVER, INFRASTRUCTURE_ACTIONS.DOWNLOAD_CSV],
    lastDiscover:        [],
    showModal:           false,
    modalActiveAccounts: []
});

const TOGGLE_SELECT_ACCOUNT_MODAL = 'TOGGLE_SELECT_ACCOUNT_MODAL';

export const toggleSelectAccountModal = () => ({type: TOGGLE_SELECT_ACCOUNT_MODAL});

const ADD_MODAL_ACTIVE_ACCOUNT = 'ADD_MODAL_ACTIVE_ACCOUNT';

export const addModalActiveAccount = account => ({
    type: ADD_MODAL_ACTIVE_ACCOUNT,
    account
});

const _addModalActiveAccount = (activesAccounts, account) => {
    if (Array.isArray(account)) {
        account.forEach(item => activesAccounts.push({id: item.id, name: item.name}));
    } else {
        activesAccounts.push({id: account.id, name: account.name});
    }

    return activesAccounts;
};

const REMOVE_MODAL_ACTIVE_ACCOUNT = 'REMOVE_MODAL_ACTIVE_ACCOUNT';

export const removeModalActiveAccount = account => ({
    type: REMOVE_MODAL_ACTIVE_ACCOUNT,
    account
});

const _removeModalActiveAccount = (activesAccounts, account) => activesAccounts.filter(item => item.id !== account.id);

const CLEAR_MODAL_ACTIVE_ACCOUNT = 'CLEAR_MODAL_ACTIVE_ACCOUNT';

export const clearModalActiveAccount = () => ({
    type: CLEAR_MODAL_ACTIVE_ACCOUNT
});

const UPDATE_DISCOVER = 'UPDATE_DISCOVER';

const LIMIT = 3;
const ATTEMPT = 1;
let discoverActive = false;

export const updateDiscover = (formatMessage, attempts) => (dispatch, getState) => {
    const {modalActiveAccounts} = getState().infrastructureResources;

    modalActiveAccounts.forEach(account => {
        dispatch(launchDiscover(formatMessage, attempts, account));
    });
};

export const launchDiscover = (formatMessage, attempts, account) => (dispatch, getState) => {
    dispatch(discoverResources({account: account.id}))
        .then(discover => {
            const lastDiscoverIndex = `Account-${account.id}`;

            if (discover) {
                const {data} = discover;
                const {lastDiscover} = getState().infrastructureResources;
                let _attempts = attempts;

                if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_QUEUED) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_QUEUED', NOTIFICATION_TYPE.INFO));
                    }

                    if (_attempts < LIMIT) {
                        _attempts = _attempts + ATTEMPT;
                        setTimeout(() => {
                            dispatch(module.exports.launchDiscover(formatMessage, _attempts, account));
                        }, TIMEOUT_DISCOVER);
                    } else {
                        discoverActive = true;
                    }

                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_LAUNCHED) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_LAUNCHED', NOTIFICATION_TYPE.INFO));
                    }

                    if (_attempts < LIMIT) {
                        _attempts = _attempts + ATTEMPT;
                        setTimeout(() => {
                            dispatch(module.exports.launchDiscover(formatMessage, _attempts, account));
                        }, TIMEOUT_DISCOVER);
                    } else {
                        discoverActive = true;
                    }

                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_SUCCESS) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_SUCCESS', NOTIFICATION_TYPE.SUCCESS));
                    }
                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_FAIL) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_FAIL', NOTIFICATION_TYPE.ERROR));
                    }
                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_UNKNOWN) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_UNKNOWN', NOTIFICATION_TYPE.ERROR));
                    }
                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_AWS_FAILED) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_AWS_FAILED', NOTIFICATION_TYPE.ERROR));
                    }
                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_AZURE_FAILED) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_AZURE_FAILED', NOTIFICATION_TYPE.ERROR));
                    }
                } else if (data.state.code === STATUS_OPERATION_DISCOVERY.STATUS_VCLOUD_FAILED) {
                    if (lastDiscover[lastDiscoverIndex] !== data.state.code) {
                        dispatch(addNotification(`Discover - ${account.name}`, 'msg.operationDiscover.STATUS_VCLOUD_FAILED', NOTIFICATION_TYPE.ERROR));
                    }
                }

                dispatch({
                    type:         UPDATE_DISCOVER,
                    id:           account.id,
                    lastDiscover: {
                        [lastDiscoverIndex]: data.state.code
                    }
                });
            } else {
                dispatch({
                    type:         UPDATE_DISCOVER,
                    id:           account.id,
                    lastDiscover: {
                        [lastDiscoverIndex]: undefined
                    }
                });
            }
        });
};

// export const updateDiscover = (formatMessage, attempts) => (dispatch, getState) => dispatch(discoverResources())


const _updateDiscover = (state, {lastDiscover, id}) => {
    let {activeButtons} = state;

    if (lastDiscover[`Account-${id}`] === STATUS_OPERATION_DISCOVERY.STATUS_QUEUED || lastDiscover[`Account-${id}`] === STATUS_OPERATION_DISCOVERY.STATUS_LAUNCHED) {
        if (~activeButtons.indexOf(INFRASTRUCTURE_ACTIONS.DISCOVER)) {
            activeButtons = activeButtons.filter(item => item !== INFRASTRUCTURE_ACTIONS.DISCOVER);
        }
    } else if (!~activeButtons.indexOf(INFRASTRUCTURE_ACTIONS.DISCOVER)) {
        activeButtons = activeButtons.concat([INFRASTRUCTURE_ACTIONS.DISCOVER]);
    }

    if (discoverActive) {
        if (Object.keys(lastDiscover).filter(key => lastDiscover[key] === STATUS_OPERATION_DISCOVERY.STATUS_QUEUED || lastDiscover[key] === STATUS_OPERATION_DISCOVERY.STATUS_LAUNCHED) === ZERO) {
            discoverActive = false;
            activeButtons = activeButtons.concat([INFRASTRUCTURE_ACTIONS.DISCOVER]);
        }
    }

    return {
        ...state,
        lastDiscover,
        activeButtons
    };


};

const UPDATE_ACTIVE_BUTTONS = 'UPDATE_ACTIVE_BUTTONS';

export const invalidateInfrastructureResources = () => dispatch => {
    dispatch(changeSelectedRows(TAG_INFRASTRUCTURE_RESOURCES, []));
    dispatch(invalidateAccounts());
    dispatch(invalidateRegions());
    dispatch(invalidateResources());
    dispatch(invalidateVendors());
    dispatch(invalidateVmStates());
    dispatch(invalidateSecurityCredentials());
};

export const updateActiveButtons = (resources, selectedRows) => ({type: UPDATE_ACTIVE_BUTTONS, resources, selectedRows});

const _updateActiveButtons = (state, {resources, selectedRows}) => {
    const ret = state.activeButtons.filter(item => item === INFRASTRUCTURE_ACTIONS.DISCOVER);

    if (resources.length) {
        const stopState = STATUS_RESOURCE.STATUS_RESOURCE_STOPPED;
        const startState = STATUS_RESOURCE.STATUS_RESOURCE_ACTIVE;

        let
            firstState = null,
            start = false,
            stop = false;

        if (selectedRows && selectedRows.length) {

            firstState = resources[selectedRows[INIT_INDEX]].status;
            for (let i = INIT_INDEX; i < selectedRows.length; i++) {
                const resource = resources[selectedRows[i]];

                if (resource.vendor && resource.vendor.code === vendorCodes.oracle) {
                    stop = false;
                    start = false;
                    break;
                }

                if (resource.status !== firstState) {
                    stop = false;
                    start = false;
                    break;
                }

                if (resource.status === startState) {
                    stop = true;
                } else if (resource.status === stopState) {
                    start = true;
                }

                if (start && stop) {
                    break;
                }
            }
        }

        start && ret.push(INFRASTRUCTURE_ACTIONS.START);
        stop && ret.push(INFRASTRUCTURE_ACTIONS.STOP);
        ret.push(INFRASTRUCTURE_ACTIONS.DOWNLOAD_CSV);
    }

    return ret;
};


// Reducers
export const reducer = (state = _defaultState(), action = {}) => {
    switch (action.type) {
    case UPDATE_ACTIVE_BUTTONS:
        return {
            ...state,
            activeButtons: _updateActiveButtons(state, action)
        };
    case UPDATE_DISCOVER:
        return _updateDiscover(state, action);
    case TOGGLE_SELECT_ACCOUNT_MODAL:
        return {
            ...state,
            showModal: !state.showModal
        };
    case ADD_MODAL_ACTIVE_ACCOUNT:
        return {
            ...state,
            modalActiveAccounts: _addModalActiveAccount(state.modalActiveAccounts, action.account)
        };
    case REMOVE_MODAL_ACTIVE_ACCOUNT:
        return {
            ...state,
            modalActiveAccounts: _removeModalActiveAccount(state.modalActiveAccounts, action.account)
        };
    case CLEAR_MODAL_ACTIVE_ACCOUNT:
        return {
            ...state,
            modalActiveAccounts: []
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/infrastructureResources.js